module.exports = __webpack_public_path__ + "static/media/imr.99f069d5.csv";